// Constants for level / XP / job progression. See docs/06-level-xp.md and docs/adr/0004.
/**
 * Asymptote of the per-job level curve L(T_job).
 * docs/06-level-xp §6.2. Per ADR 0004 every job uses the same asymptote.
 */
export const MAX_LEVEL_ASYMPTOTE = 1000;
/**
 * XP multiplier inside the re-promotion bonus band.
 * docs/06-level-xp §6.6 / docs/15-open-questions §B.6 (under ongoing review).
 */
export const JOB_XP_BONUS_MULTIPLIER = 2;
// PERMANENT_STAT_BONUS_COEFF lives in @renavora/shared (see stats.ts) so
// both the simulator and content helpers can read it without a cross-package
// dependency. Re-exported here for backward-compatible imports.
export { PERMANENT_STAT_BONUS_COEFF } from '@renavora/shared';
/** recommendedLv(dungeonTier) = dungeonTier * factor. docs/06-level-xp §6.10. */
/**
 * W1-2 (ADR 0042): unified to 10 so the documented recommended level equals
 * the IMPLEMENTED dungeon anchor (`baseEnemyLevel = tier * 10` in the starter
 * templates) that every measurement (F1 powerRatio cohort, F2 chains) and
 * the live game use. The old 16 came from docs/06 §6.10 prose that was never
 * wired to content; ADR 0042 supersedes it.
 */
export const DUNGEON_TIER_LEVEL_FACTOR = 10;
/**
 * Default restart-point ratio when re-entering a previously-visited job (no scroll).
 * restart_lv = floor(jobMaxLv * ratio). ADR 0004 §3.5.
 */
export const RESTART_RATIO_DEFAULT = 0.5;
/**
 * Restart-promotion scroll kinds and their ratio. ADR 0004 §3.5.
 * Mythic = drop-only, no craft.
 */
export const RESTART_SCROLL_KINDS = ['common', 'magic', 'rare', 'unique', 'mythic'];
export const RESTART_RATIO_BY_SCROLL = {
    common: 0.6,
    magic: 0.7,
    rare: 0.8,
    unique: 0.9,
    mythic: 1.0,
};
/**
 * Per-job tau in L(T_job) = 1000 * (1 - exp(-T_job / tau)).
 *
 * W1-2 empirical calibration (ADR 0042, supersedes the docs/06 §6.4
 * "tau ~= 745 * M, M = 100" placeholder — that anchor yields LESS than one
 * clear per level in the recommended T1-T5 band and was never measured):
 * the F2 chained-progression harness measures mean boss XP per clear
 * M ~= 48-54 once XP rides the level multiplier only (see
 * `computeRunReward`), and the ADR 0035 §2.7 band wants 3-6 clears per
 * level at the recommended level (L ~= 10-60, where one level costs
 * ~tau/(1000-L) XP). tau = targetClearsPerLevel * M * (1000 - L_mid)
 * ~= 4.5 * 51 * 965 ~= 220_000 puts every tier at ~4.4-4.6 clears/level.
 */
export const TAU_MVP_DEFAULT = 220_000;
//# sourceMappingURL=constants.js.map